import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatTableModule } from '@angular/material/table';
import { GenericTableComponent } from './generic-table/generic-table.component';

@NgModule({
  declarations: [],
  imports: [CommonModule, MatTableModule, GenericTableComponent],
})
export class SharedComponentsModule {}
